// Copyright (c) 2026 Goffy. All Rights Reserved.

export type ResolvePostGameSelectionRouteInput = {
  roundId: string;
  debug: boolean;
  tourId?: string | null;
  selectedGameDefinitionIds: ReadonlyArray<string>;
  gameDefinitionTypes: Record<string, string>;
  hasMysteryGame: boolean;
  source: string;
};

export type ResolvedRoundRoute = {
  path: string;
  query: string;
};

export function resolvePostGameSelectionRoute(input: ResolvePostGameSelectionRouteInput): ResolvedRoundRoute {
  const { roundId, debug, tourId, selectedGameDefinitionIds, gameDefinitionTypes, hasMysteryGame, source } = input;
  const hasTeamGame = selectedGameDefinitionIds.some(
    (gameId) => (gameDefinitionTypes[gameId] ?? '').trim().toLowerCase() === 'team'
  );
  const goToRoundStart = source !== 'roundstart-open' && (hasTeamGame || hasMysteryGame);
  const path = goToRoundStart ? `/round/${roundId}/roundstart` : `/round/${roundId}/hole/1/compact`;

  const params = new URLSearchParams();
  if (debug) {
    params.set('debug', 'true');
  }
  if (tourId) {
    params.set('tourId', tourId);
  }

  return {
    path,
    query: params.toString(),
  };
}

export function buildRoundRouteHref(route: ResolvedRoundRoute): string {
  return route.query ? `${route.path}?${route.query}` : route.path;
}
